<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <div>
      <h5 class="mt-28px"><i class="dot"></i> 유해·위험한 작업에 관한 안전·보건 교육 실시 현황 (중대재해처벌법 시행령 5조 2항 3)</h5>
      <p class="mt-4 mb-1" style="font-weight: 400">※ 해당없음 - 0명</p>
    </div>
    <!-- 점검표 -->
    <table-inspect-merge
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :table-header-check="[]"
      :tableHeaderNote="[{ text: '대상자', width: '200px' },{ text: '수료자', width: '200px'},]"
      content-before="numbering"
      v-model="form.inspectList"
    >
      <template #customType="{ trData, noteIndex, input }">
        <div class="p-1 flex">
          <number-input class="mr-2"
                    v-model="trData[noteIndex]"
                    type="number" :min="0" :max="99999" :readonly="board.readonly"/>
          <span class="mr-1" style="align-content: center;">명</span>
        </div>
        <div v-if="noteIndex === 1 && ((trData[0] === undefined && trData[1] !== undefined) || (Number(trData[0]) < Number(trData[1])))" class="flex">
          <img src="@/assets/images/icon/icon-circle-alert-red.svg" alt="circle" style="padding: 1px 0" class="mr-1" />
          <span style="color: #ea5455;">수료자가 너무 많습니다</span>
        </div>
      </template>
    </table-inspect-merge>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-5" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspectMerge from "@/components/TableInspectMerge";
import CompanySelector from "@/components/selector/CompanySelector";

import * as inspectData from "./inspectData";
import NumberInput from "@/components/NumberInput.vue";
import {required} from "vuelidate/lib/validators";

export default {
  components: {
    NumberInput,
    FieldSelectModule,
    FileUploadModule,
    TableInspectMerge,
    CompanySelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      inspectList: {
        $each: {
          "1": { max: (value, component) => value <= component[0], required },
        },
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inspectList: inspectData.inspectTable,
        fileList: [],

        대상자: 0,
        수료자: 0,
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);

        this.form.대상자 = this.form.inspectList.reduce((acc, cur) => {
          const value = Number(cur[0]);
          return acc + (isNaN(value) ? 0 : value);
        }, 0);

        this.form.수료자 = this.form.inspectList.reduce((acc, cur) => {
          const value = Number(cur[1]);
          return acc + (isNaN(value) ? 0 : value);
        }, 0);
      },
    },
  },
  methods: {
    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        let warning = false;
        this.form.inspectList.map((item, index) => {
          if (item[1]) {
            if (item[0] === undefined || Number(item[0]) < Number(item[1])) {
              warning = true
            }
          }
        });
        if (warning) {
          return "대상자와 수료자수를 확인해주세요";
        }
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
